export enum AuditActionCode {
  // Auth
  AUTH_LOGIN = "auth:login",
  AUTH_FORGOT_PASSWORD = "auth:forgot_password",
  AUTH_RESET_PASSWORD = "auth:reset_password",
  AUTH_CHANGE_OWN_PASSWORD = "auth:change_own_password",

  // SSO
  SSO_LOGIN = "sso:login",
  SSO_SWITCH_MERCHANT = "sso:switch_merchant",

  // Users
  USERS_CREATE = "users:create",
  USERS_UPDATE = "users:update",
  USERS_RESET_PASSWORD = "users:reset_password",
  USERS_DELETE = "users:delete",

  // Stores
  STORES_CREATE = "stores:create",
  STORES_UPDATE = "stores:update",
  STORES_BIND_CATEGORIES = "stores:bind_categories",
  STORES_UPDATE_STATUS = "stores:update_status",

  // Categories
  CATEGORIES_CREATE = "categories:create",
  CATEGORIES_UPDATE = "categories:update",
  CATEGORIES_BIND_STORE = "categories:bind_store",
  CATEGORIES_UPDATE_STATUS = "categories:update_status",
  CATEGORIES_UPDATE_FIXTURES_POG = "categories:update_fixtures_pog",

  // Store Summary
  STORE_SUMMARY_IMPORT = "store-summary:import",

  // Inputs
  INPUTS_UPDATE_PRODUCTS = "inputs:update_products",
  INPUTS_UPDATE_MASTER_FIXTURE = "inputs:update_master_fixture",
  INPUTS_UPDATE_STORE_PRODUCTS = "inputs:update_store_products",
  INPUTS_UPDATE_STORE_PRODUCTS_CSV = "inputs:update_store_products_csv",
  INPUTS_UPLOAD_PRODUCT_IMAGES = "inputs:upload_product_images",

  // Assortment distribution planner
  ASSORTMENT_DISTRIBUTION_TARGETS_UPDATE = "assortment:distribution_targets_update",
  ASSORTMENT_DISTRIBUTION_RUN = "assortment:distribution_run",
  ASSORTMENT_DISTRIBUTION_SPACE_MIX_TARGETS_UPDATE = "assortment:distribution_space_mix_targets_update",

  // Merchflow
  MERCHFLOW_REVIEW_CREATE = "merchflow:review_create",
  MERCHFLOW_DELETE = "merchflow:delete",
  MERCHFLOW_APPROVAL_UPDATE = "merchflow:approval_update",
  MERCHFLOW_PLANOGRAM_IMPORT = "merchflow:planogram_import",
  MERCHFLOW_HIGHLIGHT_BASE_POG_UPDATE = "merchflow:highlight_base_pog_update",
  MERCHFLOW_HIGHLIGHT_STORE_POG_UPDATE = "merchflow:highlight_store_pog_update",
  MERCHFLOW_BASE_POG_FAVOURITE_UPDATE = "merchflow:base_pog_favourite_update",
  MERCHFLOW_EXPORT_BATCH_CREATE = "merchflow:export_batch_create",
  MERCHFLOW_STORE_POG_UPDATE = "merchflow:store_pog_update",
  MERCHFLOW_STORE_POG_VALIDATE = "merchflow:store_pog_validate",
  MERCHFLOW_STORE_POG_DELETE = "merchflow:store_pog_delete",
  MERCHFLOW_STORE_POG_MARK_DELIVERED = "merchflow:store_pog_mark_delivered",
  MERCHFLOW_STORE_POG_BULK_MARK_DELIVERED = "merchflow:store_pog_bulk_mark_delivered",
  MERCHFLOW_BASE_POG_CREATE = "merchflow:base_pog_create",
  MERCHFLOW_BASE_POG_TRIGGER = "merchflow:base_pog_trigger",
  MERCHFLOW_BASE_POG_SAVE = "merchflow:base_pog_save",
  MERCHFLOW_FILTER_CONFIG_UPDATE = "merchflow:filter_config_update",
  MERCHFLOW_FILTER_UPDATE = "merchflow:filter_update",
  MERCHFLOW_NOTES_UPDATE = "merchflow:notes_update",
  MERCHFLOW_APPLY_TO_BASES = "merchflow:apply_to_bases",
  MERCHFLOW_APPLY_TO_BASES_COPY = "merchflow:apply_to_bases_copy",
  MERCHFLOW_FLOW_UPDATE_TRIGGER = "merchflow:flow_update_trigger",
  MERCHFLOW_PSA_UPLOAD = "merchflow:psa_upload",
  MERCHFLOW_VARIANT_RESTRICTION_UPLOAD = "merchflow:variant_restriction_upload",
  MERCHFLOW_S0_TRIGGER = "merchflow:s0_trigger",
  MERCHFLOW_PLANOGRAM_TEMPLATE_CREATE = "merchflow:planogram_template_create",
  MERCHFLOW_S1_TRIGGER = "merchflow:s1_trigger",
  MERCHFLOW_DUPLICATE = "merchflow:duplicate",

  // Projects
  PROJECTS_CREATE = "projects:create",
  PROJECTS_UPDATE = "projects:update",

  // Merchant Settings
  MERCHANT_SETTINGS_UPDATE = "merchant-settings:update",

  // Report
  REPORT_POWERBI_WORKSPACE_CREATE = "report:powerbi-workspace:create",

  // Violation
  VIOLATION_SCAN_TRIGGER = "violation:scan_trigger",

  // Import ETL
  IMPORT_ETL_RUN = "import-etl:run",

  // JDA Baseline Import
  JDA_BASELINE_IMPORT = "jda-baseline:import",

  // Fixtures Guessing
  FIXTURES_GUESSING_TRIGGER = "fixtures-guessing:trigger",

  // POG Analysis
  POG_ANALYSIS_GENERATE = "pog-analysis:generate",

  // Simulation
  SIMULATION_APPLY_UPDATE = "simulation:apply_update",

  // Admin
  ADMIN_MERCHANT_CREATE = "admin:merchant_create",
  ADMIN_USER_SET_PASSWORD = "admin:user_set_password",
}

export enum AuditResourceType {
  USER = "user",
  MERCHANT = "merchant",
  MERCHANT_SETTINGS = "merchant_settings",
  STORE = "store",
  CATEGORY = "category",
  STORE_CATEGORY = "store_category",
  PRODUCT = "product",
  STORE_PRODUCT = "store_product",
  MASTER_FIXTURE = "master_fixture",
  FLOW_REVIEW = "flow_review",
  FILTER_CONFIG = "filter_config",
  BASE_POG = "base_pog",
  STORE_POG = "store_pog",
  STORE_POG_TRIGGER = "store_pog_trigger",
  S0_TRIGGER = "s0_trigger",
  S1_TRIGGER = "s1_trigger",
  HIGHLIGHT = "highlight",
  PROJECT = "project",
  EXPORT_BATCH = "export_batch",
  UPLOAD = "upload",
  VIOLATION_SCAN = "violation_scan",
  FIXTURE_GUESSING = "fixture_guessing",
  VARIANT_RESTRICTION = "variant_restriction",
  PRODUCT_IMAGE = "product_image",
  PLANOGRAM_TEMPLATE = "planogram_template",
  ETL_IMPORT = "etl_import",
  APPROVAL = "approval",
  NOTE = "note",
  SESSION = "session",
  SIMULATION = "simulation",
}
